"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// react
var react_1 = require("react");
var utils_1 = require("@anivive/utils");
var useFetch = function (key, fetcherArg, initialData) {
    var _a = (0, react_1.useState)({
        data: initialData,
        status: null,
    }), _b = _a[0], data = _b.data, status = _b.status, setState = _a[1];
    var _c = (0, react_1.useState)(null), loading = _c[0], setLoading = _c[1];
    var fetcherMemo = (0, react_1.useMemo)(function () {
        return typeof fetcherArg === "object"
            ? {
                headers: fetcherArg.headers,
                encoding: fetcherArg.encoding,
                credentials: fetcherArg.credentials,
                mode: fetcherArg.mode,
                validateStatus: fetcherArg.validateStatus,
            }
            : fetcherArg;
    }, typeof fetcherArg === "object"
        ? [
            fetcherArg.headers,
            fetcherArg.encoding,
            fetcherArg.credentials,
            fetcherArg.mode,
            fetcherArg.validateStatus,
        ]
        : [fetcherArg]);
    var fetchData = (0, react_1.useCallback)(function (initial, revalidate) {
        if (revalidate === void 0) { revalidate = true; }
        if (initial) {
            setState({ data: initial, status: null });
        }
        if (key) {
            if (revalidate) {
                setLoading(true);
                if (typeof fetcherMemo === "function") {
                    fetcherMemo(key)
                        .then(function (res) { return setState({ data: res, status: null }); })
                        .catch(function () { return setState({ data: null, status: null }); })
                        .finally(function () { return setLoading(false); });
                }
                else {
                    var abortController = new AbortController();
                    var fetcher = (0, utils_1.Fetcher)(__assign(__assign({}, (typeof fetcherMemo === "object" && fetcherMemo)), { extended: true, signal: abortController.signal }));
                    fetcher
                        .get(key)
                        .then(function (_a) {
                        var data = _a.data, status = _a.status;
                        return setState({ data: data, status: status });
                    })
                        .catch(function (_a) {
                        var status = _a.status;
                        return ({ data: null, status: status });
                    })
                        .finally(function () { return setLoading(false); });
                    return abortController;
                }
            }
        }
        else {
            setLoading(null);
        }
        return void 0;
    }, [key, fetcherMemo]);
    (0, react_1.useEffect)(function () {
        var abortController = fetchData();
        return function () {
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
        };
    }, [key, fetcherMemo, fetchData]);
    return { data: data, status: status, loading: loading, mutate: fetchData };
};
exports.default = useFetch;
//# sourceMappingURL=index.js.map